import React from "react";
import loadable from "@loadable/component";
import withLayout from "../../../components/desktop/layout/component";
import ErrorHandler from "../../../components/shared/with-error-handler";
const StateEChallan = loadable(() => import("../../../components/desktop/state-e-challan"));
import withReducer from "../../../components/shared/with-reducer";
import injectable from "./injectable";

const StateEChallanContainer = () => {
    return (
        <ErrorHandler><StateEChallan /></ErrorHandler>
    );
};

export default withReducer(injectable)(() => ({}), dispatch => ({dispatch}))(
    withLayout(
        StateEChallanContainer,
        true,
        true,
        false,
        false
    )
);
